import get from 'lodash/get' // eslint-disable-line
import { createSelector } from 'reselect'

import { transformNormalizedToTyped } from 'packages/utils/store/store.utils'

import { ApplicationState } from '../../store'
import { UnitsState, UnitAttributeNames, Unit } from '../units.types'

const getUnitsState = (state: ApplicationState, _id: string): UnitsState =>
  state.units

const getUnitId = (_state: ApplicationState, id: string): string => id

/**
 * @deprecated Do not use this in any new code—it is not null-safe, and does not use the expected hydrator.
 * Use the newer `getUnitById` instead.
 */
export const legacyGetUnitById = createSelector(
  getUnitsState,
  getUnitId,
  (unitsState, unitId) => {
    const rawUnit = get(unitsState, `data[${unitId}]`)
    return transformNormalizedToTyped<Unit>(rawUnit, UnitAttributeNames)
  },
)
